import { render, staticRenderFns } from "./mo-clazz-dash.vue?vue&type=template&id=2c3db516&scoped=true&"
import script from "./mo-clazz-dash.vue?vue&type=script&lang=js&"
export * from "./mo-clazz-dash.vue?vue&type=script&lang=js&"
import style0 from "./mo-clazz-dash.vue?vue&type=style&index=0&id=2c3db516&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3db516",
  null
  
)

export default component.exports